import { render, staticRenderFns } from "./DeclaracaoVinculoHeader.vue?vue&type=template&id=50be2ae2&scoped=true&"
import script from "./DeclaracaoVinculoHeader.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoVinculoHeader.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoVinculoHeader.vue?vue&type=style&index=0&id=50be2ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be2ae2",
  null
  
)

export default component.exports